import "./form-fields.scss";

import { CheckboxControl, InputControl } from "wvus-forms";

/**
 * MultiselectCheckboxes component renders a list of checkboxes with optional secondary interactions.
 *
 * @param {Object} props.formMethods - Methods provided by react-hook-form for form handling.
 * @param {string} props.wrapperClass - Optional class to add to the div wrapping the checkboxes (eg: columns presentation).
 * @param {Array} props.items - An array of item objects to render checkboxes for e.g.:
 *   [{
 *     name: "",
 *     label: "",
 *     id: "",
 *     displayOnChecked: {
 *        id: "",
 *        name: "",
 *        questionText: "",
 *        placeholder: "",
 *     }
 *   }]
 *  * @returns {JSX.Element} The rendered MultiselectCheckboxes component.
 */
const MultiselectCheckboxes = ({ formMethods, items, wrapperClass = "" }) => {
  const { getFormState } = formMethods;
  const formFields = getFormState().fields;

  return (
    <div className="multi-select-checkboxes-container">
      <p className="base form_bold">Select all that apply:</p>
      <div className={["display-grid gap-base", wrapperClass].join(" ")}>
        {items
          .filter((opt) => opt.active)
          .map((item) => (
            <div key={item.id} className="labeled-checkbox">
              <CheckboxControl
                fieldName={item.name}
                fieldValue={formFields[item.name]?.value || false}
                fieldTitle={item.label}
                fieldClasses="wvus-field-newsletter-optin"
                formMethods={formMethods}
              />
              {item.displayOnChecked?.name && formFields[item.name]?.value && (
                <>
                  {item.displayOnChecked.questionText && (
                    <p>{item.displayOnChecked.questionText}</p>
                  )}
                  <InputControl
                    key={item.displayOnChecked.name}
                    formMethods={formMethods}
                    fieldName={item.displayOnChecked.name}
                    fieldValue={formFields[item.displayOnChecked.name]?.value}
                    fieldPlaceholder={item.displayOnChecked.placeholder}
                    fieldClasses="wvus-field-newsletter-optin second-interaction-field"
                    inputWrapperClasses=""
                    inputClasses=""
                    labelClasses="hidden"
                    optional
                  />
                </>
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export default MultiselectCheckboxes;
